import { Store } from "@bryntum/schedulerpro";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { View } from "../models/View.jsx";
import { GRANTS } from "../../other/constants/PrivilegeTypes.jsx";

// since we don't exactly get what is added and updated in the websocket data, this function will build an object which holds all added, updated and removed objects
const getSocketReceivedViewsAsCrud = (socketResponse, thisStore) => {
  const { rows, removed } = socketResponse;
  const crudObj = {
    addedViews: [],
    updatedViews: [],
    removedViews: []
  };

  if (rows && rows.length) {
    // checking if the view is added or updated
    rows.forEach((addOrUpdateViewRow) => {
      if (!thisStore.includes(addOrUpdateViewRow.id)) {
        crudObj.addedViews.push(addOrUpdateViewRow);
      } else {
        crudObj.updatedViews.push(addOrUpdateViewRow);
      }
    });
  }

  if (removed && removed.length) {
    crudObj.removedViews = removed;
  }

  return crudObj;
}

class ViewsStore extends Store {

  static get $name() {
    return "ViewsStore"
  }

  static get configurable() {
    return {
      id: STORE_KEYS.viewsStore,
      storeId: STORE_KEYS.viewsStore,
      modelClass: View,
      listeners: {
        idChange: "onSwivuViewIdChange",
      }
    }
  }

  onSwivuViewIdChange() {
    this.query((record) => !record.isPhantom, true)
      .forEach((record, idx) => record.order = idx);
  }

  swivuGetApplySocketChanges(e) {
    const user = this.project?.boardUsersStore?.swivuCurrentUser;
    const { addedViews, updatedViews, removedViews } = getSocketReceivedViewsAsCrud(e, this);
    const buildChangeSet = {
      added: [],
      updated: [],
      removed: []
    };

    // only add if:
      // any share check is Truthy and user is an admin
      // or share to HQ is Truthy for the other role of users
    if (addedViews.length) {
      buildChangeSet.added = addedViews.filter((addedView) => {
        const tempViewRecord = this.createRecord(addedView);
        return (tempViewRecord.isSharedView && user.can(GRANTS.grant_one)) || tempViewRecord.isShareToHQ
      });
    }

    // only update if:
      // any share check is Truthy and user is an admin
      // or share to HQ is Truthy for the other role of users
      // or view to update is a current user created view
    // else remove the view from current user board as if nothing matches above then the view probably be unshared
    if (updatedViews.length) {
      updatedViews.forEach((updatedView) => {
        const tempViewRecord = this.createRecord(updatedView);
        tempViewRecord.project = this.project;
        if ((tempViewRecord.isSharedView && user.can(GRANTS.grant_one)) || tempViewRecord.isShareToHQ || tempViewRecord.creatorUserId === user?.id) {
          buildChangeSet.updated.push(updatedView);
        } else {
          removedViews.push(updatedView);
        }
      });
    }

    // only update if:
      // this user had the view, and it was not the creator of the view since we'll not be removing the creator view
    if (removedViews.length) {
      buildChangeSet.removed = removedViews.filter((removedView) => {
        const tempViewRecord = this.createRecord(removedView);
        tempViewRecord.project = this.project;
        if (this.includes(tempViewRecord.id)) {
          return tempViewRecord.creatorUserId !== user?.id; // if some other user removed current user view then do not remove it for current user as they are creator the creator of the view
        }
        return false;
      });
    }

    return buildChangeSet;
  }
}

export default ViewsStore;
